import React from 'react';

export interface DashboardStatCardProps {
  label: string;
  value: number | string;
  subtitle: string;
  accentColor?: string;
}

export function DashboardStatCard({
  label,
  value,
  subtitle,
  accentColor = '#3b82f6',
}: DashboardStatCardProps) {
  return (
    <div
      className="d-flex align-items-center gap-3 p-3 rounded border bg-white"
      style={{ boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}
    >
      <div
        className="d-flex align-items-center justify-content-center rounded flex-shrink-0"
        style={{ width: 42, height: 42, background: `${accentColor}18`, color: accentColor }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
          <path d="M0 4s0-2 2-2h12s2 0 2 2v6s0 2-2 2h-4c0 .667.083 1.167.25 1.5H11a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1h.75c.167-.333.25-.833.25-1.5H2s-2 0-2-2V4zm1.398-.855a.758.758 0 0 0-.254.302A1.46 1.46 0 0 0 1 4.01V10c0 .325.078.502.145.602.07.105.17.188.302.254a1.464 1.464 0 0 0 .538.143L2.01 11H14c.325 0 .502-.078.602-.145a.758.758 0 0 0 .254-.302 1.464 1.464 0 0 0 .143-.538L15 9.99V4c0-.325-.078-.502-.145-.602a.757.757 0 0 0-.302-.254A1.46 1.46 0 0 0 13.99 3H2c-.325 0-.502.078-.602.145z" />
        </svg>
      </div>
      <div style={{ minWidth: 0 }}>
        <p className="fw-bold mb-1" style={{ fontSize: '22px', lineHeight: 1, color: '#111827', letterSpacing: '-0.5px' }}>
          {typeof value === 'number' ? value.toLocaleString() : value}
        </p>
        <p className="fw-semibold text-uppercase mb-0" style={{ fontSize: '11px', letterSpacing: '0.6px', color: '#9ca3af' }}>
          {label}
        </p>
        <p className="mb-0" style={{ fontSize: '11px', color: '#6b7280' }}>
          {subtitle}
        </p>
      </div>
    </div>
  );
}
